import { isNotNil } from '../../isNotNil';

/**
 * RN 기본 Deeplink 형식을 만듭니다
 */
export const getDefaultDeeplink = () => {
  return buildUrl('ably://react/App');
};

/**
 * 기본 WebView link를 만듭니다
 * @param titleBar
 */
export const getDefaultWebviewLink = (titleBar?: boolean) => {
  const link = buildUrl('ably://webview');
  if (isNotNil(titleBar)) {
    appendParams(link, 'title_bar', titleBar ? 'true' : 'false');
  }
  return link;
};

/**
 * Path를 URL class로 변경합니다
 * @param path
 */
export const buildUrl = (path: string) => {
  return new URL(path);
};

/**
 * 필요한 Params를 추가합니다
 * @param url
 * @param name
 * @param value
 */
export const appendParams = (url: URL, name: string, value: string) => {
  return url.searchParams.set(name, value);
};

/**
 * 딥링크 동작시키기 전, 필요한 처리를 합니다
 * @param url
 */
export const finalizeUrl = (url: URL) => {
  return url.href.replaceAll('+', '%20');
};
